// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media all and (min-width: 480px) {
  body {
    background: rgb(255, 255, 255);
  }
  .Login {
    padding: 10px 0;
    color: rgb(255, 255, 255);
    text-align: left;
  }

  .Logo2bad-login {
    margin: auto;
    display: flex;
    width: 500px;
    text-align: center;
    height: auto;
  }

  .Login form {
    margin: auto;
    max-width: 280px;
    color: #000;
  }

  .btn-primary.disabled,
  .btn-primary:disabled {
    color: rgb(255, 255, 255);
    background-color: #e60012;
    border-color: #000000;
  }
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;EACvB;AACF;AACA;EACE;CACD,WAAW;EACV;AACF","sourcesContent":["@media all and (min-width: 480px) {\n  body {\n    background: rgb(255, 255, 255);\n  }\n  .Login {\n    padding: 10px 0;\n    color: rgb(255, 255, 255);\n    text-align: left;\n  }\n\n  .Logo2bad-login {\n    margin: auto;\n    display: flex;\n    width: 500px;\n    text-align: center;\n    height: auto;\n  }\n\n  .Login form {\n    margin: auto;\n    max-width: 280px;\n    color: #000;\n  }\n\n  .btn-primary.disabled,\n  .btn-primary:disabled {\n    color: rgb(255, 255, 255);\n    background-color: #e60012;\n    border-color: #000000;\n  }\n}\n@media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
